import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ValidationErrorInterface } from '@zaoblako/shared/common/interfaces/validation-error.interface';
import type { DeadlineFormInterface } from '@zaoblako/shared/common/dtos/deadline/deadline-form.dto';
import { DeadlineTypeEnum } from '@zaoblako/shared/common/enums/deadline.type.enum';
import { DeadlineMonthTypeSingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/deadline-month-type-single-select/deadline-month-type-single-select.component';
import { DeadlineTypeSingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/deadline-type-single-select/deadline-type-single-select.component';
import { JoinPipe } from '@zaoblako/web/shared/pipes/join.pipe';
import { InputNumberModule } from 'primeng/inputnumber';

@Component({
  standalone: true,
  selector: 'crm-planning-deadline-form',
  templateUrl: './planning-deadline-form.component.html',
  imports: [
    CommonModule,
    DeadlineTypeSingleSelectComponent,
    JoinPipe,
    InputNumberModule,
    FormsModule,
    DeadlineMonthTypeSingleSelectComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDeadlineFormComponent {
  @Input() public planning: DeadlineFormInterface = <DeadlineFormInterface>{};
  @Input() public errors: ValidationErrorInterface<DeadlineFormInterface>;

  @Input() public appendTo: string;

  public get DeadlineTypeEnum() {
    return DeadlineTypeEnum;
  }
}
